export const modalsConfig = {
  default: "/static/img/content/hyper/modalBackground.png",
};
